import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SjoborgTrackingLinkService {
  protected trackingUrls: { [packageLev: string]: string } = {
    DHL: 'https://www.dhl.com/se-sv/home/tracking/tracking-express.html?submit=1&tracking-id=',
    PostNord: 'https://www.postnord.se/vara-verktyg/spara-brev-paket-och-pall/?shipmentId='
  };

  getTrackingLink(packageLev: string, packageNumber: string): string | undefined {
    const baseUrl = this.trackingUrls[packageLev];
    if (!baseUrl || !packageNumber) {
      return undefined;
    }
    return baseUrl + packageNumber;
  }
}
